import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { encryptData } from "../../utils/storage";
import toast from "react-hot-toast";
import { RestfullApiService } from "../../config/service";

import DefaultEventImg from "../../assets/img/masthead/default-event.png";
import { MEDIA_URL } from "../../config/url";
import "../../assets/css/events.css";
import { removeSpace } from "../../utils";
import { useSelector } from "react-redux";

const Events = ({ eventtable }) => {
  const navigate = useNavigate();
  const [eventTableList, setEventTableList] = useState([]);
  const [visibleItems, setVisibleItems] = useState(6);
  const [tab2visibleItems, setTab2VisibleItems] = useState(6);
  const [activetab, setActivetab] = useState("tab-1");

  const user = useSelector((state) => state.user.userProfile);
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  // const user = JSON.parse(localStorage.getItem("userProf"));

  const handleLoadMore = () => {
    setVisibleItems((prevVisibleItems) => prevVisibleItems + 6); // Load 5 more items each time
  };
  const handleTab2LoadMore = () => {
    setTab2VisibleItems((prevVisibleItems) => prevVisibleItems + 6); // Load 5 more items each time
  };
  const addToWishlist = async (EventId, EventName, index) => {
    if (!user) {
      console.error("User data not found");
      return;
    }

    const reqdata = {
      Org_Id: user?.Org_Id,
      Session_User_Id: user?.Participant_Id,
      Session_User_Name: `${user?.First_Name} ${user?.Last_Name}`,
      Method_Name: "AddTowish",
      Event_Id: EventId,
      Display_Name: EventName,
    };

    try {
      const result = await RestfullApiService(
        reqdata,
        "participant/wishlist_set"
      );

      if (result) {
        console.log("Add operation successful:", result);
        toast.success("Added to Wishlist!");

        setEventTableList((prevList) => {
          const updatedList = [...prevList];
          updatedList[index].Isin_wishlist = EventId;
          return updatedList;
        });
      }
    } catch (err) {
      console.error("API Error:", err);
      toast.error("Failed to add to wishlist");
    }
  };
  const deleteFromWishlist = async (EventId, EventName, index) => {
    if (!user) {
      console.error("User data not found");
      return;
    }

    const reqdata = {
      Org_Id: user?.Org_Id,
      Session_User_Id: user?.Participant_Id,
      Session_User_Name: `${user?.First_Name} ${user?.Last_Name}`,
      Method_Name: "Delete",
      Event_Id: EventId,
      Display_Name: EventName,
    };

    try {
      const result = await RestfullApiService(
        reqdata,
        "participant/wishlist_set"
      );

      if (result) {
        console.log("Delete operation successful:", result);
        toast.error("Removed from Wishlist!");

        setEventTableList((prevList) => {
          const updatedList = [...prevList];
          updatedList[index].Isin_wishlist = "false";
          return updatedList;
        });
      }
    } catch (err) {
      console.error("API Error:", err);
      toast.error("Failed to remove from wishlist");
    }
  };
  const handleLoginCheck = (index, eventId, eventName, isInWishlist) => {
    if (!isLoggedIn) {
      navigate("login");
    } else {
      if (isInWishlist === "false") {
        addToWishlist(eventId, eventName, index);
      } else {
        deleteFromWishlist(eventId, eventName, index);
      }
    }
  };
  const shareContent = async (eventId, displayName) => {
    const encryptedParam = encryptData(eventId);
    const url1 = window.location.href;
    const url = `${url1}event-details/${removeSpace(
      displayName
    )}/${encryptedParam}`;
    // const message = `${displayName}\n${url}`;
    const message = `${url}`;
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Check out this awesome content!",
          text: message, // Full message including the URL
          // Omitting url property
        });
        console.log("Content shared successfully");
      } catch (error) {
        console.error("Error sharing content:", error);
      }
    } else {
      console.log("Share API not supported");
      // Optionally provide a fallback here
    }
  };

  useEffect(() => {
    const arr = Object.values(eventtable);
    setEventTableList(arr);
  }, [eventtable]);

  return (
    <>
      <section className="layout-pt-sm layout-pb-md">
        <div className="container">
          <div
            // data-anim-child="slide-up delay-2"
            className="tabs -pills-2 js-tabs"
          >
            <div className="row justify-between items-center">
              <div className="col-auto">
                <div className="sectionTitle -md">
                  <h2 className="sectionTitle__title text-primary">
                    Find Your Next Event
                  </h2>
                </div>
              </div>
              <div className="col-auto lg:d-none">
                <div className="tabs__controls row x-gap-15 justify-center js-tabs-controls">
                  <div className="col-auto">
                    <button
                      className={`tabs__button text-18 fw-500 rounded-4 text-light-1 border-dark-1 js-tabs-button${
                        activetab === "tab-2" ? " is-tab-el-active" : ""
                      } lh-1`}
                      data-tab-target=".-tab-item-2"
                      onClick={() => {
                        setActivetab("tab-2");
                      }}
                    >
                      <i className="fas fa-list"></i>
                    </button>
                  </div>
                  <div className="col-auto">
                    <button
                      className={`tabs__button text-18 fw-500 rounded-4 text-light-1 border-dark-1 js-tabs-button${
                        activetab === "tab-1" ? " is-tab-el-active" : ""
                      } lh-1`}
                      data-tab-target=".-tab-item-1"
                      onClick={() => {
                        setActivetab("tab-1");
                      }}
                    >
                      <i className="fas fa-th-large"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="tabs__content pt-20">
              {/* js-tabs-content */}
              <div
                className={`tabs__pane -tab-item-1${
                  activetab === "tab-1" ? " is-tab-el-active" : ""
                }`}
              >
                <div className="row y-gap-40">
                  {eventTableList.length > 0 &&
                    eventTableList
                      ?.slice(0, visibleItems)
                      ?.map((rowdata, index) => {
                        var arraytypevent =
                          rowdata.Event_Category_List?.split(",");
                        const encryptedParam = encryptData(rowdata?.Event_Id);

                        return (
                          <div
                            className="col-xl-4 col-lg-4 col-sm-6"
                            key={`L${rowdata.Event_Id}`}
                          >
                            <div
                              className="border-light rounded-16 px-15 py-15 -hover-shadow cursor-pointer h-full relative"
                              // onClick={() => {

                              // }}
                            >
                              <div className="eventsCard -type-1">
                                <div className="eventsCard__image">
                                  <div className="cardImage ratio ratio-2:1">
                                    <div className="cardImage__content">
                                      <img
                                        className="rounded-16 col-12"
                                        src={
                                          rowdata.Image_Path
                                            ? `${MEDIA_URL}${rowdata.Image_Path}`
                                            : DefaultEventImg
                                        }
                                        // src={DefaultEventImg}
                                        alt="card_image"
                                      />
                                    </div>
                                    <div className="cardImage__wishlist d-flex">
                                      <div>
                                        <button
                                          onClick={() => {
                                            handleLoginCheck(
                                              index,
                                              rowdata.Event_Id,
                                              rowdata.Display_Name,
                                              rowdata.Isin_wishlist
                                            );
                                          }}
                                          className={`button ${
                                            rowdata.Isin_wishlist !== "false"
                                              ? "addedEvent rounded-full"
                                              : " bg-white size-30 rounded-full shadow-2 text-primary"
                                          }`}
                                        >
                                          {/* <i className="far fa-heart text-12"></i> */}
                                          {rowdata.Isin_wishlist !== "false" ? (
                                            <i className="fas fa-heart text-12"></i>
                                          ) : (
                                            <i className="far fa-heart text-12"></i>
                                          )}
                                        </button>
                                      </div>
                                      <button
                                        onClick={() =>
                                          shareContent(
                                            rowdata?.Event_Id,
                                            rowdata.Display_Name
                                          )
                                        }
                                        className="button -primary-1 bg-white size-30 rounded-full shadow-2 text-primary"
                                      >
                                        <i className="fas fa-share text-12"></i>
                                      </button>
                                    </div>

                                    {/* <div className="cardImage__leftBadge">
                                  <div className="px-15 rounded-right-4 text-12 lh-16 fw-600 uppercase bg-primary text-white">
                                    {rowdata?.Start_Date}
                                  </div>
                                </div> */}
                                    <div className="cardImage__leftBadge">
                                      <div className="px-20 rounded-right-4 text-14 lh-16 fw-700 uppercase bg-white text-dark">
                                        {rowdata?.Start_Date ===
                                        rowdata?.End_Date
                                          ? rowdata?.Start_Date
                                          : rowdata?.Start_Date +
                                            " - " +
                                            rowdata?.End_Date}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className="eventsCard__content mt-10 relative"
                                  // style={{
                                  //   height: "56%",
                                  //   flexDirection: "column",
                                  // }}
                                  onClick={() => {
                                    // window.location.replace(
                                    //   `/event-details/${removeSpace(
                                    //     rowdata?.Display_Name
                                    //   )}/${encryptedParam}`
                                    // );

                                    navigate(
                                      `/event-details/${removeSpace(
                                        rowdata?.Display_Name
                                      )}/${encryptedParam}`
                                    );
                                    window.location.reload();
                                  }}
                                >
                                  <h4 className="eventsCard__title text-dark-1 text-15 lh-13 fw-600">
                                    <span>{rowdata.Display_Name}</span>
                                  </h4>
                                  <div className="mt-10">
                                    <span className="text-light-1 lh-14 text-12 fw-500 mt-5 font-inter">
                                      <i className="fas fa-map-marker-alt text-primary text-12 fw-600"></i>{" "}
                                      {rowdata.City_Name}, {rowdata.State}
                                    </span>
                                    <span className="text-light-1 lh-14 text-12 fw-500 mt-5 ml-10 font-inter">
                                      <i className="fas fa-running text-primary text-12 fw-600"></i>{" "}
                                      {rowdata.EventType_Name}
                                    </span>

                                    {/* {rowdata.Rating === 0 ? (
                                    <></>
                                  ) : (
                                    <span className="text-light-1 lh-14 text-12 fw-500 mt-5 ml-10 fr font-inter">
                                      <i className="fas fa-star text-green text-12 fw-600"></i>{" "}
                                      {rowdata.Rating}
                                    </span>
                                  )} */}
                                  </div>
                                  <div className="d-flex items-center flex-wrap mt-10 font-inter uppercase">
                                    {/* {arraytypevent?.map((datatype, index) => {
                                    if (index > 1) {
                                      return;
                                    }
                                    return (
                                      <div
                                        className="bg-light-2 rounded-16 text-10 fw-600 text-dark-1 py-5 px-15 lh-1 m-1"
                                        key={`ML${datatype}`}
                                      >
                                        {datatype}
                                      </div>
                                    );
                                  })}
                                  {arraytypevent?.length > 1 ? (
                                    <div className="text-10 fw-500 text-light underline">
                                      <Link
                                        to={`/event-details/${encryptedParam}`}
                                      >
                                        +1 more..
                                      </Link>
                                    </div>
                                  ) : (
                                    ""
                                  )} */}

                                    {arraytypevent
                                      ?.slice(0, 2)
                                      .map((datatype, index) => (
                                        <div
                                          key={`ML${index}`}
                                          // className="col-auto"
                                        >
                                          <div className="bg-light-2 rounded-16 text-10 fw-600 text-dark-1 py-5 px-15 lh-1 m-1">
                                            {datatype.toUpperCase()}
                                          </div>
                                        </div>
                                      ))}
                                    {arraytypevent?.length > 2 && (
                                      <div className="text-10 fw-500 text-light underline">
                                        <Link
                                          to={`/event-details/${removeSpace(
                                            rowdata?.Display_Name
                                          )}/${encryptedParam}`}
                                        >
                                          +{arraytypevent.length - 2} more..
                                        </Link>
                                      </div>
                                    )}
                                  </div>
                                  <div className="mt-15 pb-10 border-bottom-primary">
                                    <p className="text-10 fw-600 font-inter text-light-1">
                                      Registrations{" "}
                                      {rowdata?.Is_Registration_Closed ===
                                      "Closed"
                                        ? "Closed"
                                        : "Closing"}{" "}
                                      on{" "}
                                      <span className="text-primary">
                                        {rowdata.Registration_Date}
                                      </span>
                                    </p>
                                  </div>
                                  <div className="cardbottom">
                                    <div className="mt-20 d-flex justify-between relative font-inter">
                                      <div className="fw-700 text-20">
                                        {rowdata?.Amount !== "Free" && (
                                          <span className="text-12 fw-500 text-light-1 mr-4">
                                            ₹
                                          </span>
                                        )}
                                        {rowdata?.Amount}{" "}
                                        {rowdata?.Amount !== "Free" && (
                                          <span className="ml-5 text-10 fw-400 tex-light-1">
                                            Onwards
                                          </span>
                                        )}
                                      </div>
                                      <div className="d-flex justify-center items-center">
                                        {rowdata.Is_Registration_Closed ===
                                        "Open" ? (
                                          <Link
                                            to={`/event-details/${removeSpace(
                                              rowdata?.Display_Name
                                            )}/${encryptedParam}`}
                                            className="button -sm bg-primary -pmdark-1 text-white rounded-25 text-12 px-15 py-10"
                                          >
                                            Register Now
                                          </Link>
                                        ) : (
                                          <Link
                                            to="#"
                                            className="text-primary text-12 px-20 fw-500"
                                            style={{ cursor: "default" }}
                                          >
                                            Registration Closed
                                          </Link>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                </div>
                {eventTableList.length > visibleItems ? (
                  <div className="row justify-center pt-40">
                    <div className="col-auto">
                      <button
                        onClick={handleLoadMore}
                        // href="event/list"
                        className="button px-30 py-10 text-primary rounded-22 underline"
                      >
                        View More
                      </button>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {/* {visibleItems > 5 ? (
                  <div className="row justify-center pt-40">
                    <div className="col-auto">
                      <button
                        onClick={() => {
                          setVisibleItems((prevVisible) => prevVisible - 5);
                        }}
                        // href="event/list"
                        className="button px-30 py-10 text-primary rounded-22 underline"
                      >
                        View Less
                      </button>
                    </div>
                  </div>
                ) : (
                  <></>
                )} */}
              </div>
              <div
                className={`tabs__pane -tab-item-2${
                  activetab === "tab-2" ? " is-tab-el-active" : ""
                }`}
              >
                <div className="row y-gap-30">
                  {eventtable?.slice(0, tab2visibleItems)?.map((rowdata) => {
                    var arraytypevent = rowdata.Event_Category_List?.split(",");
                    const encryptedParam = encryptData(rowdata?.Event_Id);

                    return (
                      <div
                        className="col-xl-12 col-lg-12 col-sm-12"
                        key={`EL${rowdata.Event_Id}`}
                      >
                        <div className="border-light rounded-16 px-15 py-15 -hover-shadow">
                          <div className="eventsCard__content">
                            <div className="row items-center">
                              <div className="col-xl-1 col-lg-2 col-sm-6 border-right">
                                <h2 className="text-18 text-primary fw-700 text-center lg:mb-15">
                                  {/* {rowdata.Start_Date} */}
                                  {rowdata?.Start_Date}
                                </h2>
                              </div>
                              <div className="col-xl-4 col-lg-4 col-sm-6">
                                <h4 className="eventsCard__title text-dark-1 text-15 lh-13 fw-600">
                                  <a
                                    href={`/event-details/${removeSpace(
                                      rowdata?.Display_Name
                                    )}/${encryptedParam}`}
                                  >
                                    <span>{rowdata.Display_Name}</span>
                                  </a>
                                </h4>
                                <div className="mt-10">
                                  <span className="text-light-1 lh-14 text-12 fw-500 mt-5 font-inter">
                                    <i className="fas fa-map-marker-alt text-primary text-12 fw-600"></i>{" "}
                                    {rowdata.City_Name}, {rowdata.State}
                                  </span>
                                  <span className="text-light-1 lh-14 text-12 fw-500 mt-5 ml-10 font-inter">
                                    <i className="fas fa-running text-primary text-12 fw-600"></i>{" "}
                                    {rowdata.EventType_Name}
                                  </span>
                                  {/* {rowdata.Rating === 0 ? (
                                    <></>
                                  ) : (
                                    <span className="text-light-1 lh-14 text-12 fw-500 mt-5 ml-10 font-inter">
                                      <i className="fas fa-star text-green text-12 fw-600"></i>{" "}
                                      {rowdata.Rating}
                                    </span>
                                  )} */}
                                </div>
                              </div>
                              <div className="col-xl-5 col-lg-5 col-sm-6">
                                <div className="d-flex items-center flex-wrap mt-10 font-inter">
                                  {arraytypevent?.map((datatype) => {
                                    return (
                                      <div
                                        className="bg-light-2 rounded-16 text-10 fw-600 text-dark-1 py-5 px-15 lh-1 m-1 uppercase"
                                        key={`LM${datatype}`}
                                      >
                                        {datatype}
                                      </div>
                                    );
                                  })}
                                </div>
                                <div className="mt-10 pb-5">
                                  <p className="text-10 text-light-1 font-inter fw-500">
                                    Registrations{" "}
                                    {rowdata?.Is_Registration_Closed ===
                                    "Closed"
                                      ? "Closed"
                                      : "Closing"}{" "}
                                    on{" "}
                                    <span className="text-primary">
                                      {rowdata.Registration_Date}
                                    </span>
                                  </p>
                                </div>
                              </div>
                              <div className="col-xl-2 col-lg-2 col-sm-6">
                                <div className="fw-700 text-20 font-inter">
                                  {rowdata?.Amount !== "Free" && (
                                    <span className="text-12 fw-500 text-light-1 mr-4">
                                      ₹
                                    </span>
                                  )}
                                  {rowdata?.Amount}{" "}
                                  {rowdata?.Amount !== "Free" && (
                                    <span className="ml-5 text-10 fw-400 tex-light-1">
                                      Onwards
                                    </span>
                                  )}
                                </div>
                                <div className="mt-5 font-inter">
                                  {rowdata.Is_Registration_Closed === "Open" ? (
                                    <Link
                                      to={`/event-details/${removeSpace(
                                        rowdata?.Display_Name
                                      )}/${encryptedParam}`}
                                      className="button -sm -pmdark-1 bg-primary text-white rounded-25 text-12 py-10"
                                    >
                                      Register Now
                                    </Link>
                                  ) : (
                                    <Link
                                      to="#"
                                      className="text-primary text-12 pr-20 lg:px-0 fw-500"
                                    >
                                      Registration Closed
                                    </Link>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                {eventTableList.length > tab2visibleItems ? (
                  <div className="row justify-center pt-40">
                    <div className="col-auto">
                      <button
                        // href="event/list"
                        onClick={handleTab2LoadMore}
                        className="button px-30 py-10 text-primary rounded-22 underline"
                      >
                        View More
                      </button>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Events;
